import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { VerificationService, assertValidSegmentName, SegmentEnum } from '@sheerid/jslib';

interface Props {
    verificationService: VerificationService;
}

const UploadInfoComponent: React.SFC<Props> = ({ verificationService }) => {
    const segment = verificationService.verificationResponse.segment;
    assertValidSegmentName(segment);

    switch (segment) {
        case SegmentEnum.STUDENT:
            return (
                <div>
                    <span>
                        <strong>
                            <FormattedHTMLMessage
                                id="step.docUpload.uploadInstructions"
                                defaultMessage="Please upload your school-issued document that shows:"
                            />
                        </strong>
                    </span>
                    <ul className="sid-upload-info-list">
                        <li className="sid-upload-info-list__li">
                            <FormattedHTMLMessage
                                id="step.docUpload.uploadInfo.fullName"
                                defaultMessage="Your full name"
                            />
                        </li>
                        <li className="sid-upload-info-list__li">
                            <FormattedHTMLMessage
                                id="step.docUpload.uploadInfo.student.school"
                                defaultMessage="Your School"
                            />
                        </li>
                        <li className="sid-upload-info-list__li">
                            <FormattedHTMLMessage
                                id="step.docUpload.uploadInfo.student.enrollmentDate"
                                defaultMessage="Date that proves current enrollment <span class='sid-wrap'>(or within last 3 months)</span>"
                            />
                        </li>
                    </ul>
                </div>
            );
        default:
            return null;
    }
};

export { UploadInfoComponent };
